export default import.meta.ROLLDOWN_FILE_URL__rs0KstFpz7xtOUuuLO2aw